/**
 * There will be one reducer file per page / common component
 */
import {
    GET_PRODUCTSGUIDE_SUCCESS,
    GET_PRODUCTSGUIDE_FAILURE,
    GET_PRODUCTSGUIDE,
    SET_PRODUCTSGUIDE,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
    CLEAR_PRODUCTS_GUIDE,
    SET_PRODUCTGUIDE_FILTER_OPEN,
    SET_SELECTED_CATEGORY,
    SET_APPLIED_FILTER,
    SET_SELECTED_CATEGORY_FILTER,
    SET_SELECTED_SUB,
    GET_PRODUCT_CATOGORY_LIST,
    GET_PRODUCT_CATOGORY_LIST_SUCCESS,
    GET_PRODUCT_CATOGORY_LIST_FAILURE,
    SET_SEARCHPARAM_PRODUCT_GUIDE,
    SET_APPLIED_BRAND_VALUES,
    SET_PAGE_NUM,
    SET_SUB_CATEGORY,
    GLOBAL_FILTER_OPEN,
    CLOSE_SHOW_PAGE,
    SET_APPLIED_SUBCATEGORY,
    UPDATE_SUBCATEGORY_REFINE_DATA,
    SET_APPLIED_BRANDS,
    UPDATE_BRANDS_DATA,
    SET_PRODUCT_GUIDE_VALUES,
    SET_SELECTED_TAB,
    SET_SORT_CODE,
    CLEAR_PRODUCTS_GUIDE_DATA,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import { generate_UUID } from 'src/utils/util';

const initialState = {
    productGuideValue: false,
    selectedBrands: [],
    selectedSubCategory: [],
    productGuideData: {
        subCategoryRefineData: [
            {
                subCategoryClassificationCode: '',
                subCategoryClassificationName: '',
                classificationRefineData: [], //checked
            },
        ],
    },
    pageNum: 0,
    pageLimit: 50,
    categoryAndBrands: {},
    productsGuideError: '',
    categoryAndBrandLoading: false,
    productsGuideLoading: false,
    subCategoryLoading: false,
    productGuideFilterOpen: false,
    selectedCategory: '',
    appliedFilter: [],
    selectedSubCategoryIn: [],
    // subCategoryRefineData: [],
    productList: [],
    feeProductsTotalCount: 0,
    setProductsCount: 0,
    itemProductsCount: 0,
    productsTotalCount: 0,
    statusMessage: '',
    productDataLoading: false,
    searchParamProductGuide: '',
    selectedSubCat: [],
    globalFilterBoxOpen: false,
    showPage: false,
    selectedCategoryFilter: '',
    appliedSubCategory: [],
    appliedBrands: [],
    selectedTab: 'Sets',
    sortOrderCode: 'ProductCode-asc',
};

const updateProductsGuide = (list, name, state) => {
    if (name === 'approach') {
        return {
            ...state,
            subCategoryRefineData: list,
        };
    }
    // if (name === 'pageNum') {
    //     return {
    //         ...state,
    //         pageNum: list,
    //     };
    // }
    if (name === 'productBrands') {
        return {
            ...state,
            selectedBrands: list,
        };
    }
};

const ProductsGuideReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCTSGUIDE:
            return {
                ...state,
                ...updateProductsGuide(action.payload, action.name, state),
            };
        case GET_PRODUCTSGUIDE:
            return {
                ...state,
                productsLoading: true,
            };
        case GET_PRODUCTSGUIDE_SUCCESS:
            return {
                ...state,
                productsGuide: action.productsGuide,
                productsGuideError: '',
                productsGuideLoading: false,
            };
        case GET_PRODUCTSGUIDE_FAILURE:
            return {
                ...state,
                productsGuide: [],
                productsGuideError: action.templateError,
                productsGuideLoading: false,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA:
            return {
                ...state,
                categoryAndBrandLoading: true,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS:
            return {
                ...state,
                categoryAndBrands: action.categoryAndBrands,
                productsGuideError: '',
                categoryAndBrandLoading: false,
            };
        case GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE:
            return {
                ...state,
                categoryAndBrands: [],
                productsGuideError: action.templateError,
                categoryAndBrandLoading: false,
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY:
            return {
                ...state,
                // subCategoryLoading: true,
                productDataLoading: true,
                productList: [],
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS:
            return {
                ...state,
                productList:
                    action.productGuideData?.productList?.length > 0
                        ? action.productGuideData.productList?.map((d) => {
                              return {
                                  ...d,
                                  productKey: generate_UUID(),
                              };
                          })
                        : action.productGuideData?.productList,
                feeProductsTotalCount:
                    action.productGuideData.feeProductsTotalCount,
                itemProductsCount: action.productGuideData.itemProductsCount,
                productsTotalCount: action.productGuideData.productsTotalCount,
                setProductsCount: action.productGuideData.setProductsCount,
                statusMessage: action.productGuideData.statusMessage,
                categoryAndBrands: {
                    ...state.categoryAndBrands,
                    brandData: action.productGuideData.brandRefineData,
                    categoryData:
                        action.productGuideData?.categoryData ||
                        state.categoryAndBrands.categoryData,
                },
                productsGuideError: '',
                productDataLoading: false,
                appliedBrandValues: [],

                // subCategoryLoading: false,
            };
        case GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE:
            return {
                ...state,
                // productGuideData: [],
                productDataLoading: false,
                productsGuideError: action.templateError,
                // subCategoryLoading: false,
            };
        case GET_PRODUCT_CATOGORY_LIST:
            return {
                ...state,
                subCategoryLoading: true,
            };
        case GET_PRODUCT_CATOGORY_LIST_SUCCESS:
            return {
                ...state,
                productGuideData: {
                    subCategoryRefineData:
                        action.productGuideData.subCategoryRefineData,
                },
                categoryAndBrands: {
                    ...state.categoryAndBrands,
                    brandData: action.productGuideData.brandRefineData,
                    categoryData:
                        action.productGuideData?.categoryData ||
                        state.categoryAndBrands.categoryData,
                },
                productsGuideError: '',
                subCategoryLoading: false,
            };
        case GET_PRODUCT_CATOGORY_LIST_FAILURE:
            return {
                ...state,
                // productGuideData: [],
                productsGuideError: action.templateError,
                subCategoryLoading: false,
            };
        case CLEAR_PRODUCTS_GUIDE:
            return {
                ...state,
                productGuideData: [],
            };

        case SET_PRODUCTGUIDE_FILTER_OPEN:
            return {
                ...state,
                productGuideFilterOpen: action.payload,
            };

        case SET_SELECTED_CATEGORY:
            return {
                ...state,
                selectedCategory: action.payload,
            };
        case SET_APPLIED_FILTER:
            return {
                ...state,
                appliedFilter: action.payload,
            };
        case SET_SELECTED_CATEGORY_FILTER:
            return {
                ...state,
                selectedCategoryFilter: action.payload,
            };
        case SET_SELECTED_SUB:
            return {
                ...state,
                selectedSubCat: action.payload,
            };
        case SET_SEARCHPARAM_PRODUCT_GUIDE:
            return {
                ...state,
                searchParamProductGuide: action.payload,
            };
        case SET_APPLIED_BRAND_VALUES:
            return {
                ...state,
                appliedBrandValues: action.payload,
            };
        case SET_PAGE_NUM:
            return {
                ...state,
                pageNum: action.payload,
            };
        case SET_SUB_CATEGORY:
            return {
                ...state,
                subCategory: action.payload,
            };
        case GLOBAL_FILTER_OPEN:
            return {
                ...state,
                globalFilterBoxOpen: action.payload,
            };

        case CLOSE_SHOW_PAGE:
            return {
                ...state,
                showPage: action.payload,
            };
        case SET_APPLIED_SUBCATEGORY:
            return {
                ...state,
                appliedSubCategory: [...action.payload],
            };
        case UPDATE_SUBCATEGORY_REFINE_DATA:
            return {
                ...state,
                productGuideData: {
                    ...state.productGuideData,
                    subCategoryRefineData: action.payload,
                },
            };
        case SET_APPLIED_BRANDS:
            return {
                ...state,
                appliedBrands: [...action.payload],
            };
        case UPDATE_BRANDS_DATA:
            return {
                ...state,
                categoryAndBrands: {
                    ...state.categoryAndBrands,
                    brandData: action.payload,
                },
                selectedBrands: action.payload,
            };
        case SET_PRODUCT_GUIDE_VALUES:
            return {
                ...state,
                productGuideValue: action.payload,
            };
        case SET_SELECTED_TAB:
            return {
                ...state,
                selectedTab: action.payload,
            };
        case SET_SORT_CODE:
            return {
                ...state,
                sortOrderCode: action.payload,
            };
        case CLEAR_PRODUCTS_GUIDE_DATA:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default ProductsGuideReducer;
